

import React, { Fragment, useState } from 'react'

export default function LicenseSearch({ searchHandler }) {

    const [searchQuery, setSearchQuery] = useState("")
    const [searchType, setSearchType] = useState("email")

    const handleQueryChange = event => setSearchQuery(event.target.value)
    const handleTypeChange = event => setSearchType(event.target.value)

    const handleSearch = () => {
        searchHandler({ query: searchQuery, type: searchType })
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            //   console.log('do validate');
            handleSearch()
        }

    }


    const handleKeyUp = () => {

        if (searchQuery.length <= 0) {
            handleSearch()
        }
    }

    return (

        <Fragment>
            <div className="input-group search-field">

                <span className=" w-100 form-icon-wrapper">
                    <span class="form-icon form-icon--left">
                        <select class="custom-select" value={searchType} onChange={handleTypeChange}>
                            <option value={"email"}>Email</option>
                            <option value={"name"} >Name</option>
                            <option value={"license"}>License</option>
                            <option value={"country"}>Country</option>
                        </select>
                    </span>
                    <span className="form-icon  form-icon--right" onClick={handleSearch}>
                        <i className="fa fa-search form-icon__item"></i>
                    </span>
                    <input type="text" onen value={searchQuery} onKeyUp={handleKeyUp} onKeyDown={handleKeyDown} className="form-control form-icon-input-left" type="search" placeholder="Type to search…" onChange={handleQueryChange} />
                </span>
            </div>
        </Fragment >

    )
}
